export var CustomerType;
(function (CustomerType) {
    CustomerType["Private"] = "private";
    CustomerType["Corporate"] = "corporate";
})(CustomerType || (CustomerType = {}));
